import { render, staticRenderFns } from "./StopRatingReportDetails.vue?vue&type=template&id=fa6f38ea&scoped=true&"
import script from "./StopRatingReportDetails.vue?vue&type=script&lang=js&"
export * from "./StopRatingReportDetails.vue?vue&type=script&lang=js&"
import style0 from "./StopRatingReportDetails.vue?vue&type=style&index=0&id=fa6f38ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa6f38ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fa6f38ea')) {
      api.createRecord('fa6f38ea', component.options)
    } else {
      api.reload('fa6f38ea', component.options)
    }
    module.hot.accept("./StopRatingReportDetails.vue?vue&type=template&id=fa6f38ea&scoped=true&", function () {
      api.rerender('fa6f38ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Reports/StopRatingReportDetails.vue"
export default component.exports